import { render, staticRenderFns } from "./SummaryNepaleseAdReport.vue?vue&type=template&id=a547a6ba&scoped=true&"
import script from "./SummaryNepaleseAdReport.vue?vue&type=script&lang=js&"
export * from "./SummaryNepaleseAdReport.vue?vue&type=script&lang=js&"
import style0 from "./SummaryNepaleseAdReport.vue?vue&type=style&index=0&id=a547a6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a547a6ba",
  null
  
)

export default component.exports